import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PristynCareForm from './pristynCareForm';
import NotFoundPage from '../../components/home/NotFoundPage';

const PristynCareNavigator = () => {
  return (
    <Switch>
      <Route path="/pristyn-care/form" exact component={PristynCareForm} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
};

export default PristynCareNavigator;
